import { render, staticRenderFns } from "./PlaidOAuthHandler.vue?vue&type=template&id=b5c19aae&scoped=true&"
import script from "./PlaidOAuthHandler.vue?vue&type=script&lang=js&"
export * from "./PlaidOAuthHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c19aae",
  null
  
)

export default component.exports